const setHistory = url => {
  const defaultUrl = window.location.pathname
  const newUrl = url || defaultUrl
  window.history.pushState(
    '',
    document.title,
    newUrl
  )
}

export default setHistory
